/**
 * @file 权限检查工具函数
 */
import store from '@/store'
import authConfig from '@/common/config/auth'

/**
 * 检查用户是否有权限
 * @param {String} moduleName - 模块名
 * @param {String|Array} funName - 功能名或功能名数组
 * @returns {Boolean} 是否有权限
 */
export function hasAuth(moduleName, funName) {
    if (Object.prototype.toString.call(funName) === '[object Array]') {
        const multiPermission = funName.every((item) => {
            return hasAuth(moduleName, item)
        })
        return multiPermission
    }
    let permissions = store.state.userInfo.permissions
    if (!(permissions && Object.keys(permissions).length)) {
        return false
    }
    // 模块名不存在，视为没有权限
    if (!moduleName) {
        return false
    }
    if (authConfig[moduleName] && authConfig[moduleName][funName] && permissions[authConfig[moduleName][funName]]) {
        return true
    }
    return false
}

